/**
 * Dynamically loads font CSS for personalisation fonts.
 * @param {string[]} fontNames - Array of font names to load
 */
export const loadPersonalisationFonts = (fontNames) => {
  // Remove any existing personalisation font styles
  const existingStyle = document.getElementById('personalisation-fonts');
  if (existingStyle) {
    existingStyle.remove();
  }

  // Generate CSS for each font
  const fontCSS = fontNames
    .map((fontName) => {
      const fontFileName = fontName.replace(/\s+/g, '-');
      return `
      @font-face {
        font-family: '${fontName}';
        src: url('${window.personalisationFontUrls[`${fontFileName}`]}') format('woff2');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
      }
    `;
    })
    .join('');

  // Create and inject the style tag
  const styleTag = document.createElement('style');
  styleTag.id = 'personalisation-fonts';
  styleTag.textContent = fontCSS;
  document.head.appendChild(styleTag);
};
